export default __webpack_public_path__ + "95539fb16f.ttf";